module.exports = __webpack_public_path__ + "img/w17-b1.475d2ea5.jpg";